import ERPSelectionTiles from './ERPSelectionTiles';

export default ERPSelectionTiles;
